import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Work" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  const dark = pathname === "/" || pathname === "/portfolio";
  const useLight = scrolled || !dark;

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        useLight ? "bg-white/75 backdrop-blur-xl border-black/10" : "bg-black/40 backdrop-blur-xl border-white/10"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-16 h-[68px] flex items-center justify-between">
        <Logo light={!useLight} />
        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `link-underline text-sm font-medium tracking-wide transition-opacity ${
                  useLight ? "text-black" : "text-white"
                } ${isActive ? "opacity-100" : "opacity-60 hover:opacity-100"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta"
            className={`btn-fill text-sm font-semibold px-5 py-2.5 border ${
              useLight ? "border-black text-black" : "border-white text-white"
            }`}
          >
            Start a project
          </Link>
        </nav>
        <button
          data-testid="mobile-menu-toggle"
          className={`md:hidden ${useLight ? "text-black" : "text-white"}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black text-white px-6 py-8 flex flex-col gap-5">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className="font-display text-3xl tracking-tight" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="mt-4 bg-[#D4FF00] text-black text-center py-3 font-semibold">
            Start a project
          </Link>
        </div>
      )}
    </header>
  );
};
